import { ReactNode } from "react";
import classNames from "classnames";

import RotatingAnimation from "./RotatingAnimation";
import Icon360 from "./Icon360";
import { QA_QTVR_OVERLAY_BUTTON } from "../../modules/Data/static";
import "./UiMCMEQtvrOverlay.scss";

interface UiMCMEQtvrOverlayProps {
  onClick: () => void;
  isVisible?: boolean;
  imageDisclaimer: ReactNode;
}

const UiMCMEQtvrOverlay = ({
  onClick,
  isVisible,
  imageDisclaimer,
}: UiMCMEQtvrOverlayProps) => (
  <div
    className={classNames("UiMCMEQtvrOverlay", {
      "UiMCMEQtvrOverlay--hidden": !isVisible,
    })}
  >
    <button
      className="UiMCMEQtvrOverlay__content"
      onClick={onClick}
      data-qa={QA_QTVR_OVERLAY_BUTTON}
    >
      <div className="UiMCMEQtvrOverlay__icons">
        <div className="UiMCMEQtvrOverlay__rotatingAnimation">
          <RotatingAnimation />
        </div>
        <div className="UiMCMEQtvrOverlay__icon360">
          <Icon360 />
        </div>
      </div>
      <div className="UiMCMEQtvrOverlay__text">CLICK TO EXPLORE</div>
    </button>
    {imageDisclaimer}
  </div>
);

export default UiMCMEQtvrOverlay;
